import { defineStore } from 'pinia';
import { computed } from 'vue';
import { useContentRefData } from '@ilteducation/content-ref-data';
import type { Language } from '@ilteducation/content-ref-data-types/models/data-types';
import config from '../config/ConfigProvider';

const useLanguagesStore = defineStore('languages', () => {
  const refDataStore = useContentRefData();
  const languages = computed(() => {
    const refDataLangs = refDataStore.all('languages') as Language[];
    // Ukrainian is called 'uk' in ref data, but we use 'ukr' in Babelfish/Lokalise so we add a duplicate entry
    const ukrainian = refDataLangs.find((lang) => lang.languageCode === 'uk');
    if (ukrainian) {
      return [
        ...refDataLangs,
        {
          ...ukrainian,
          languageCode: 'ukr',
        },
      ];
    }
    return refDataLangs;
  });
  const supportedAreaGuideContentLanguages = [
    'ar',
    'de',
    'en-gb',
    'es',
    'prs',
    'fr',
    'ru',
    'sv',
    'ukr',
    'ur',
    'so',
    'ti',
  ];

  const getLanguageByShortcode = (code: string) => languages.value.find((lang) => lang.languageCode === code);

  const getMarketLanguage = () => {
    const { countryCode } = config.CONFIG;

    switch (countryCode) {
      case 'no':
        return 'nb';
      case 'fi':
        return 'fi';
      default:
        return 'sv';
    }
  };

  return {
    languages,
    getLanguageByShortcode,
    getMarketLanguage,
    supportedAreaGuideContentLanguages,
  };
});

export default useLanguagesStore;
